import intersection from 'lodash/intersection'

export function getToken() {
  return localStorage.getItem('app.token')
}

export function checkAccess(required = [], granted = []) {
  return intersection(required, granted).length > 0 || required.length === 0
}
